// @ts-ignore: Unreachable code error
import { configureStore } from "@reduxjs/toolkit";
import skuReducer from "./reduces/skuSlice";

export const store = configureStore({
  reducer: {
    sku: skuReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
